import React from 'react';
import { Route } from 'react-router-dom';
import themes from '../themes';
import PageTransition from '../components/transitions/PageTransition';

const StationRoute = ({ station, buttonCount }) => {
  return Array.from({ length: buttonCount }, (_, index) => {
    const button = index + 1;
    const Component = React.lazy(() => import(`../pages/${station}/Taste${button}`));

    return (
      <Route
        key={`${station}/taste${button}`}
        path={`/${station}/taste${button}`}
        element={
          <PageTransition theme={themes[station]}>
            <React.Suspense fallback={<div>Laden...</div>}>
              <Component />
            </React.Suspense>
          </PageTransition>
        }
      />
    );
  });
};

export default StationRoute;
